module.exports = __webpack_public_path__ + "static/media/estateEmgeaMobile.4213a0c3.jpg";